import events from './events';
import game from './game';
import jigsawEvents from './jigsawEvents';
import wordleEvents from './wordleEvents';

export default [game, events, wordleEvents, jigsawEvents];
